"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 绘制一个图元切片
 * @param p 左上角点
 * @param pat 图元切片
 */
function putPattern(p, pat) {
    return function (ctx) {
        ctx.save();
        ctx.fillStyle = pat.pattern;
        ctx.fillRect(p[0], p[1], pat.width, pat.height);
        ctx.restore();
    };
}
exports.putPattern = putPattern;
/**
 * 生成路径图元
 * @param path 路径
 * @param closed 是否关闭路径
 */
function putPath(path, closed) {
    if (closed === void 0) { closed = false; }
    return function (ctx) {
        ctx.beginPath();
        ctx.moveTo.apply(ctx, __spread(path[0]));
        for (var i = 1; i < path.length; i++) {
            ctx.lineTo.apply(ctx, __spread(path[i]));
        }
        if (closed) {
            ctx.closePath();
        }
        ctx.stroke();
    };
}
exports.putPath = putPath;
/**
 * 生成圆图元
 * @param circle 圆
 */
function putCircle(circle) {
    return function (ctx) {
        ctx.beginPath();
        var _a = __read(circle, 2), _b = __read(_a[0], 2), x = _b[0], y = _b[1], r = _a[1];
        ctx.arc(x, y, r, 0, 2 * Math.PI);
        ctx.stroke();
    };
}
exports.putCircle = putCircle;
function putRect(rectPos, filled) {
    return function (ctx) {
        ctx.beginPath();
        if (filled) {
            ctx.fillRect.apply(ctx, __spread(rectPos));
        }
        else {
            ctx.strokeRect.apply(ctx, __spread(rectPos));
        }
    };
}
exports.putRect = putRect;
/**
 * 全画布渲染图像源
 * @param imageSource 图像源
 */
function putImageSource(imageSource, pos) {
    return function (ctx) {
        var _a = __read(pos || [0, 0, ctx.canvas.width, ctx.canvas.height], 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        ctx.drawImage(imageSource, x, y, w, h);
    };
}
exports.putImageSource = putImageSource;
//# sourceMappingURL=R.js.map